import type {
  CreateDraftContractMutationOptions,
  CreateDraftContractPayload,
} from './types';

import { useMutation } from '@tanstack/react-query';

import { createDraftContract } from './createDraftContract';

/**
 * Starts a draft contract for the create form. Nothing is invalidated: an
 * unsaved draft is not part of any contract list.
 *
 * @param options - Additional mutation options.
 * @returns The mutation.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/create_draft_contract_contracts_drafts_post
 */
export const useMutationCreateDraftContract = (
  options?: CreateDraftContractMutationOptions,
) =>
  // oxlint-disable-next-line react-doctor/query-mutation-missing-invalidation
  useMutation({
    ...options,
    mutationFn: (payload: CreateDraftContractPayload) =>
      createDraftContract(payload),
  });
